import React, { useState, useEffect } from "react";
import "./prixodrasxodmoney.css";

const API = "/php";

const Prixodrasxodmoney = ({ setChecked, sentTelegram }) => {
    useEffect(() => { setChecked("4"); }, []);

    const currentMonth = new Date().getMonth() + 1;
    const [checkedMonth, setCheckedMonth] = useState(`${currentMonth}`);
    const [viewerlist, setviewerlist] = useState([]);
    const [loading, setLoading] = useState(false);
    const [prixodrasxod, setprixodrasxod] = useState("1");
    const [selected, setSelected] = useState("");
    const [selected2, setSelected2] = useState("");

    // Форма
    const [typeMoney, settypeMoney] = useState("");
    const [operation, setoperation] = useState("");
    const [source, setsource] = useState("");
    const [name, setname] = useState("");
    const [summa, setsumma] = useState("");

    const options = ["Абонентская плата", "Продажа GPS", "Прочие", "Салауат Ага"];

    // =============================================
    // Загрузка данных из MySQL
    // =============================================
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await fetch(`${API}/get_prixodrasxodmoney.php?month=${checkedMonth}`);
                const data = await res.json();
                if (data.status === "success") setviewerlist(data.data);
                else { console.error(data.message); setviewerlist([]); }
            } catch (err) {
                console.error("Fetch error:", err);
                setviewerlist([]);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [checkedMonth]);

    // Активный месяц (CSS)
    useEffect(() => {
        for (let i = 1; i <= 12; i++) {
            const el = document.querySelector(`.abonentplata-month-span${i}`);
            if (el) el.classList.toggle("active", checkedMonth === String(i));
        }
    }, [checkedMonth]);

    // Активный фильтр (CSS)
    useEffect(() => {
        for (let i = 1; i <= 3; i++) {
            const el = document.querySelector(`.prixodrasxodmoney-box1-filter-span${i}`);
            if (el) el.classList.toggle("active", prixodrasxod === String(i));
        }
    }, [prixodrasxod]);

    const toggleAddMoney = () => {
        document.querySelector(".addPrixod")?.classList.toggle("active");
    };

    // =============================================
    // Добавление записи
    // =============================================
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!typeMoney.trim() || !operation.trim() || !source.trim() || !name.trim() || !summa) {
            alert("Заполните все поля");
            return;
        }
        const payload = { typeMoney, operation, source, name, summa, month: checkedMonth };
        try {
            const res = await fetch(`${API}/add_money.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });
            const json = await res.json();
            if (json.ok) {
                // MySQL возвращает snake_case — нормализуем
                const item = normalizeItem(json.item);
                setviewerlist(prev => [item, ...(prev || [])]);
                sentTelegram({ typeMoney, operation, source, name, summa });
                settypeMoney(""); setoperation(""); setsource(""); setname(""); setsumma("");
                toggleAddMoney();
            } else {
                alert("Ошибка: " + (json.error || "unknown"));
            }
        } catch (err) {
            console.error(err);
            alert("Ошибка сети");
        }
    };

    // Нормализация snake_case → camelCase (MySQL → JSX)
    const normalizeItem = (item) => ({
        ...item,
        typeMoney: item.typeMoney ?? item.type_money ?? "",
        operation: item.operation ?? "",
        source: item.source ?? "",
        name: item.name ?? "",
        summa: item.summa ?? 0,
        date: item.date ?? "",
        status: item.status ?? "",
    });

    const months = [
        ["1", "Январь"], ["2", "Февраль"], ["3", "Март"], ["4", "Апрель"],
        ["5", "Май"], ["6", "Июнь"], ["7", "Июль"], ["8", "Август"],
        ["9", "Сентябрь"], ["10", "Октябрь"], ["11", "Ноябрь"], ["12", "Декабрь"]
    ];

    const list = (viewerlist || []).map(normalizeItem);

    return (
        <section className="prixodrasxodmoney">
            <div className="prixodrasxodmoney-flex">

                {/* ----- Месяцы ----- */}
                <div className="abonentplata-month">
                    <div className="abonentplata-month-h5">
                        <h5>{new Date().getFullYear()}</h5>
                    </div>
                    {months.map(([num, label]) => (
                        <span key={num}
                            className={`abonentplata-month-span abonentplata-month-span${num}`}
                            onClick={() => setCheckedMonth(num)}>
                            {label}
                        </span>
                    ))}
                </div>

                {/* ----- Форма добавления ----- */}
                <div className="addPrixod" onClick={toggleAddMoney}>
                    <div className="addPrixod-flex" onClick={(e) => e.stopPropagation()}>
                        <span className="addPrixod-flex-box">
                            <h6>Тип оплаты:</h6>
                            <select value={typeMoney} onChange={(e) => settypeMoney(e.target.value)}>
                                <option value="">Выбрать...</option>
                                <option value="Наличка">Наличка</option>
                                <option value="Перечисление">Перечисление</option>
                            </select>
                        </span>
                        <span className="addPrixod-flex-box">
                            <h6>Операция:</h6>
                            <select value={operation} onChange={(e) => setoperation(e.target.value)}>
                                <option value="">Выбрать...</option>
                                <option value="Приход">Приход</option>
                                <option value="Расход">Расход</option>
                            </select>
                        </span>
                        <span className="addPrixod-flex-box">
                            <h6>Источник:</h6>
                            <select value={source} onChange={(e) => setsource(e.target.value)}>
                                <option value="">Выбрать...</option>
                                {options.map((opt, idx) => (
                                    <option key={idx} value={opt}>{opt}</option>
                                ))}
                            </select>
                        </span>
                        <span className="addPrixod-flex-box">
                            <h6>Наименование:</h6>
                            <input type="text" value={name} onChange={(e) => setname(e.target.value)} />
                        </span>
                        <span className="addPrixod-flex-box">
                            <h6>Сумма:</h6>
                            <input type="number" value={summa} onChange={(e) => setsumma(e.target.value)} />
                        </span>
                        <div className="addPrixod-flex-box-button">
                            <button onClick={handleSubmit}>Выполнить</button>
                        </div>
                    </div>
                </div>

                {/* ----- Основной блок ----- */}
                <div className="prixodrasxodmoneybox-flex">
                    <div className="prixodrasxodmoney-box1">
                        <div className="prixodrasxodmoney-box1-filter">
                            <span className="prixodrasxodmoney-box1-filter-span prixodrasxodmoney-box1-filter-span1" onClick={() => setprixodrasxod("1")}>Все</span>
                            <span className="prixodrasxodmoney-box1-filter-span prixodrasxodmoney-box1-filter-span2" onClick={() => setprixodrasxod("2")}>Приход</span>
                            <span className="prixodrasxodmoney-box1-filter-span prixodrasxodmoney-box1-filter-span3" onClick={() => setprixodrasxod("3")}>Расход</span>
                        </div>
                        <div className="prixodrasxodmoney-box1-filter3">
                            <span className="prixodrasxodmoney-box1-filter3box">
                                <h6>Приход:</h6>
                                <span>
                                    {list.reduce((sum, item) =>
                                        sum + (item.operation === "Приход" ? Number(item.summa) || 0 : 0), 0
                                    ).toLocaleString("ru-RU")}
                                </span>
                            </span>
                            <span className="prixodrasxodmoney-box1-filter3box">
                                <h6>Расход:</h6>
                                <span>
                                    {list.reduce((sum, item) =>
                                        sum + (item.operation === "Расход" ? Math.abs(Number(item.summa)) : 0), 0
                                    ).toLocaleString("ru-RU")}
                                </span>
                            </span>
                            <span className="prixodrasxodmoney-box1-filter3box">
                                <h6>Остаток:</h6>
                                <span>
                                    {list.reduce((sum, item) =>
                                        sum + (Number(item.summa) || 0), 0
                                    ).toLocaleString("ru-RU")}
                                </span>
                            </span>
                        </div>
                        <div className="prixodrasxodmoney-box1-filter2">
                            <h6>Тип оплаты:</h6>
                            <select onChange={(e) => setSelected(e.target.value)}>
                                <option value="">Все</option>
                                <option value="Наличка">Наличка</option>
                                <option value="Перечисление">Перечисление</option>
                            </select>
                        </div>
                        <div className="prixodrasxodmoney-box1-filter2">
                            <h6>Источник:</h6>
                            <select onChange={(e) => setSelected2(e.target.value)}>
                                <option value="">Все</option>
                                {options.map((opt, idx) => (
                                    <option key={idx} value={opt}>{opt}</option>
                                ))}
                            </select>
                        </div>
                        <div className="prixodgps-box1-addbutton" onClick={toggleAddMoney}>+</div>
                    </div>

                    {/* ----- Таблица ----- */}
                    {loading ? <div className="loader"></div> : (
                        <table className="prixodrasxodmoney-list-table">
                            <thead>
                                <tr className="prixodrasxodmoney-list-table-sticky">
                                    <th>№</th>
                                    <th>Дата</th>
                                    <th>Тип оплаты</th>
                                    <th>Операция</th>
                                    <th>Источник</th>
                                    <th>Наименование</th>
                                    <th>Сумма</th>
                                </tr>
                            </thead>
                            <tbody>
                                {list
                                    .sort((a, b) => b.id - a.id)
                                    .filter(koks => {
                                        const matchType = (koks.typeMoney || "").toLowerCase().includes(selected.toLowerCase());
                                        const matchSource = (koks.source || "").toLowerCase().includes(selected2.toLowerCase());
                                        let matchFilter = true;
                                        if (prixodrasxod === "2") matchFilter = koks.operation === "Приход";
                                        else if (prixodrasxod === "3") matchFilter = koks.operation === "Расход";
                                        return matchFilter && matchType && matchSource;
                                    })
                                    .map(koks => (
                                        <tr key={koks.id}
                                            style={{
                                                color: koks.operation === "Расход" ? "red" : koks.operation === "Приход" ? "green" : "",
                                                backgroundColor: koks.status == 3 ? "#ffe5e5" : koks.status === "2" ? "#96ebc556" : ""
                                            }}>
                                            <td>{koks.id}</td>
                                            <td>{koks.date}</td>
                                            <td>{koks.typeMoney}</td>
                                            <td>{koks.operation}</td>
                                            <td>{koks.source}</td>
                                            <td>{koks.name}</td>
                                            <td>{Math.abs(Number(koks.summa)).toLocaleString('ru-RU')}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Prixodrasxodmoney;
